import { Component, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef  as MatDialogRef} from '@angular/material/legacy-dialog';
import { TranslateService } from '@ngx-translate/core';

export enum AiConfirmationType {
    ArchitectualArt,
    Book,
    Exhibition,
    FeesWithConfirmation,
    FeesWithoutConfirmation,
    Movie,
    Single,
}

@Component({
    selector: 'app-confirmation-dialog',
    templateUrl: './ai-confirmation.component.html',
    styleUrls: ['./ai-confirmation.component.scss']
})
export class AiConfirmationComponent {
    isConfirmed = false;
    text: string;

    constructor(
        private translate: TranslateService,
        public dialogRef: MatDialogRef<AiConfirmationComponent>,
        @Inject(MAT_DIALOG_DATA) public type: AiConfirmationType
    ) {
        const key = AiConfirmationType[type];
        this.text = this.translate.instant(`aiConfirmation.${key}`);
    }

    onCancel(): void {
        this.dialogRef.close(false);
    }

    onConfirm(): void {
        this.dialogRef.close(true);
    }
}
